import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import { cn } from "@utils";
import { formatAmount } from "../../utils/Formatters";
import Input from "./Input";

const CurrencyInput = ({
  name,
  control,
  displayName,
  required,
  min,
  max,
  disabled,
  readonly,
  placeholder,
  onChange: onValueChange,
  errors,
  className,
  validate,
}) => {
  const hasInteracted = useRef(false);

  return (
    <div className={cn("", className)}>
      <Controller
        className={cn("", className)}
        name={name}
        control={control}
        rules={{
          required: required ? `${displayName} is required` : null,
          min: min
            ? {
                value: min,
                message: `${displayName} must be greater than ${formatAmount(
                  min
                )}`,
              }
            : null,
          max: max
            ? {
                value: max,
                message: `${displayName} must be less than ${formatAmount(max)}`,
              }
            : null,
          validate,
        }}
        render={({ field: { ref, onChange, onBlur, value, ...field } }) => {
          const num = parseFloat(value);
          const displayValue = !hasInteracted.current && Number.isFinite(num)
            ? num.toFixed(2)
            : (value ?? "");

          return (
            <Input
              {...field}
              value={displayValue}
              type="text"
              prefix="£"
              disabled={disabled}
              readonly={readonly}
              placeholder={placeholder ?? "123.45"}
              invalid={!!errors}
              onFocus={() => { hasInteracted.current = true; }}
              onChange={(e) => {
                const raw = e.target.value;
                if (!raw || /^\d+(\.\d{0,2})?$/.test(raw)) {
                  onChange(raw);
                  onValueChange?.(raw);
                }
              }}
              onBlur={(e) => {
                const raw = e.target.value;
                const num = parseFloat(raw);
                const formatted = Number.isFinite(num) ? num.toFixed(2) : "";
                onChange(formatted);
                onValueChange?.(formatted);
                onBlur();
              }}
            />
          );
        }}
      />
    </div>
  );
};

export default CurrencyInput;
